import { imgUrl } from "@/lib/api";

const esc = (s) =>
  String(s ?? "").replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));

export function printLesson(lesson) {
  if (!lesson) return;
  const d = lesson.documents || {};
  const storyboard = d.storyboard || [];
  const script = d.script || [];
  const assessment = d.assessment || {};
  const standards = d.standards_explained || [];

  const storyboardHtml = storyboard
    .map(
      (s) => `
      <div class="sb">
        ${s.image_url ? `<img src="${imgUrl(s.image_url)}" alt="scene"/>` : `<div class="ph">Scene ${esc(s.scene)}</div>`}
        <div class="sb-body">
          <h4>Scene ${esc(s.scene)} · ${esc(s.title)}</h4>
          <p>${esc(s.description)}</p>
          <p class="narr">"${esc(s.narration)}"</p>
        </div>
      </div>`
    )
    .join("");

  const scriptHtml = script
    .map(
      (l) => `<div class="line"><span class="spk">${esc(l.speaker)}</span> <span class="sc">Scene ${esc(l.scene)}</span><p>${esc(l.lines)}</p>${l.audio_cue ? `<em>SFX: ${esc(l.audio_cue)}</em>` : ""}</div>`
    )
    .join("");

  const quizHtml = (assessment.questions || [])
    .map((q, i) => {
      const opts = (q.options || [])
        .map((o) => {
          const letter = String(o).trim()[0];
          const correct = String(q.answer || "").trim().toUpperCase().startsWith((letter || "").toUpperCase());
          return `<li class="${correct ? "correct" : ""}">${esc(o)}${correct ? " ✓" : ""}</li>`;
        })
        .join("");
      return `<div class="q"><p><strong>${i + 1}. ${esc(q.question)}</strong></p><ul>${opts}</ul>${q.explanation ? `<p class="exp">Explanation: ${esc(q.explanation)}</p>` : ""}</div>`;
    })
    .join("");

  const standardsHtml = standards
    .map(
      (st) => `<div class="std"><span class="code">${esc(st.code)}</span><strong>${esc(st.title)}</strong><p>${esc(st.explanation)}</p><p class="how"><em>How this lesson meets it:</em> ${esc(st.how_addressed)}</p></div>`
    )
    .join("");

  const html = `<!doctype html><html><head><meta charset="utf-8"/>
  <title>${esc(lesson.title)} — Lesson Pack</title>
  <style>
    * { box-sizing: border-box; }
    body { font-family: -apple-system, "Segoe UI", Roboto, sans-serif; color:#0F172A; margin:0; padding:40px; }
    h1 { font-size:26px; margin:0 0 4px; }
    .meta { color:#4F46E5; font-weight:700; font-size:12px; text-transform:uppercase; letter-spacing:1px; margin-bottom:24px; }
    h2 { font-size:18px; border-bottom:2px solid #4F46E5; padding-bottom:6px; margin:32px 0 14px; }
    h4 { margin:0 0 6px; font-size:14px; }
    .sb { display:flex; gap:14px; border:1px solid #E2E8F0; border-radius:10px; padding:12px; margin-bottom:12px; page-break-inside:avoid; }
    .sb img { width:220px; height:130px; object-fit:cover; border-radius:8px; flex:none; }
    .ph { width:220px; height:130px; background:#F1F5F9; border-radius:8px; display:flex; align-items:center; justify-content:center; color:#94A3B8; }
    .sb-body p { margin:4px 0; font-size:13px; }
    .narr { font-style:italic; color:#475569; }
    .line { border:1px solid #E2E8F0; border-radius:8px; padding:10px 12px; margin-bottom:8px; page-break-inside:avoid; }
    .spk { background:#EEF2FF; color:#4F46E5; font-weight:700; padding:2px 8px; border-radius:20px; font-size:12px; }
    .sc { color:#94A3B8; font-size:11px; margin-left:8px; }
    .line p { margin:6px 0 2px; font-size:13px; }
    .line em { color:#64748B; font-size:11px; }
    .q { margin-bottom:14px; page-break-inside:avoid; }
    .q ul { list-style:none; padding:0; margin:6px 0; }
    .q li { padding:5px 10px; border:1px solid #E2E8F0; border-radius:6px; margin:4px 0; font-size:13px; }
    .q li.correct { border-color:#059669; background:#ECFDF5; color:#065F46; font-weight:600; }
    .exp { font-size:12px; color:#64748B; }
    .std { border:1px solid #E2E8F0; border-radius:8px; padding:12px; margin-bottom:10px; page-break-inside:avoid; }
    .code { background:#EEF2FF; color:#4F46E5; font-family:monospace; padding:2px 8px; border-radius:6px; font-size:12px; margin-right:8px; }
    .std p { font-size:13px; margin:6px 0; }
    .how { color:#475569; }
    @media print { body { padding:20px; } }
  </style></head><body>
    <h1>${esc(lesson.title)}</h1>
    <div class="meta">${esc(lesson.grade)} · ${esc(lesson.subject)} · ${esc(lesson.topic)} · ${esc(lesson.state)} · ${esc(lesson.style)} style</div>
    <h2>Storyboard</h2>${storyboardHtml || "<p>No storyboard.</p>"}
    <h2>Script</h2>${scriptHtml || "<p>No script.</p>"}
    <h2>Student Assessment${assessment.title ? ` — ${esc(assessment.title)}` : ""}</h2>${quizHtml || "<p>No quiz.</p>"}
    <h2>State Standards</h2>${standardsHtml || "<p>No standards.</p>"}
    <script>window.onload=function(){setTimeout(function(){window.print();},600);};</script>
  </body></html>`;

  const w = window.open("", "_blank");
  if (!w) return;
  w.document.open();
  w.document.write(html);
  w.document.close();
}
